<app-aifc-header></app-aifc-header>

<router-outlet></router-outlet>

@if (isFooterVisible$ | async) {
  <app-aifc-footer></app-aifc-footer>
}

<app-cookie-banner></app-cookie-banner>
